module.exports = __webpack_public_path__ + "img/Slice24.94882388.png";